export class UltimaLeituraUmidadeSensoresModel {
    ativo: boolean;
    instante: string;
    umidade: any[];
}
